import { ActionCellRendererItems } from "common/models/action-cell-renderer.model";
import React from "react";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import './ActionCellRenderer.scss';

interface ActionCellRendererProps {
    rowData:any;
    actionItems:Array<ActionCellRendererItems>;
    onActionClicked: (rowData:any,actionName:string) => void;
  }
  
  const ActionCellRenderer: FC<ActionCellRendererProps> = ({
    rowData,
    actionItems,
    onActionClicked,
  }) => {
    return rowData ?(
        <div className="action-cell-renderer">
            {actionItems?.map((action:ActionCellRendererItems, i) => 
              <React.Fragment key={action?.actionName || i}>
                {!action?.isActionDisabled && !action?.disablingCondition && (
                <div className={'enabledAction '+action?.actionName}>
                    <img src={action?.actionSrc}  onClick={() => onActionClicked(rowData,action?.actionName)}/>
                </div>
                )}
                {!action?.isActionDisabled && action?.disablingCondition && !eval(action?.disablingCondition) && (
                <div className={'enabledAction '+action?.actionName}>
                    <img src={action?.actionSrc}  onClick={() => onActionClicked(rowData,action?.actionName)}/>
                </div>
                )}
                {(action?.isActionDisabled || action?.disablingCondition && eval(action?.disablingCondition)) && (
                 <div className={'disabledAction '+action?.actionName}>
                   <img src={action?.actionSrc} />
                 </div>  
                )}
              </React.Fragment>
              
            )}
        </div>
    ):<></>
  }

  export default ActionCellRenderer